import React from "react";
import { useLang } from "@/i18n";
import YukiPanel from "@/components/YukiPanel";

export default function Accounting() {
  const { t } = useLang();
  return (
    <div className="space-y-6" data-testid="accounting-page">
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{t("navAdmin")}</div>
        <h1 className="font-display text-3xl font-bold">{t("accounting")}</h1>
        <p className="text-muted-foreground mt-1 text-sm">{t("accountingTagline")}</p>
      </div>
      <YukiPanel />
    </div>
  );
}
